// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: pure location helpers for the tasks list, kept out of the store so the
// nav's matching rules can be tested on their own.

import type {KonvoTask} from '@app/features/konvo_tasks/state/KonvoTasks';

/**
 * Nav ids a task sits under. Selecting a space matches everything beneath it,
 * so the ids are cumulative rather than just the deepest one.
 */
export function locationIdsForTask(task: KonvoTask): Array<string> {
	const ids: Array<string> = [];
	ids.push(task.space.id ? `space:${task.space.id}` : 'space:—');
	if (task.folder.id) ids.push(`folder:${task.folder.id}`);
	if (task.list.id) ids.push(`list:${task.list.id}`);
	return ids;
}
